module.exports = __webpack_public_path__ + "img/banner.423fd9fe.png";